var context = require.context('./images/', false, /\.png$/);
var icons = {};

// load all icons into a big array of paths
context.keys().forEach((filename) => {
  icons[filename.slice(2, -4)] = context(filename);
});

export default icons;


// WEBPACK FOOTER //
// ./src/walleris/ICONS.js